import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import { useEditSegmentView } from "../EditSegment.context";

export function useEditSegmentHeader() {
  const { mdUp } = useBreakpoints();

  const {
    cancelEditName,
    editDisabled,
    editDisabledTooltip,
    editName,
    gotoView,
    nameEditing,
    openSummary,
    previewDisabled,
    saveName,
    segmentName,
    summaryOpen,
    goBack,
  } = useEditSegmentView();

  return {
    nameEditing,
    editName,
    saveName,
    mdUp,
    segmentName,
    cancelEditName,
    previewDisabled,
    gotoView,
    summaryOpen,
    openSummary,
    editDisabled,
    editDisabledTooltip,
    goBack,
  };
}
